import classNames from 'classnames'
import styled from 'styled-components'

import { FontWeight } from 'types/enums'
import { BorderVariant } from 'types/enums/style/input/border-variant/border-variant'

export interface ITextProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    className?: string
    onChange?: React.ChangeEventHandler<HTMLInputElement>
    id: string
    color?: string
    hasBorder?: boolean
    borderVariant?: BorderVariant
    icon?: React.ReactNode
    height?: string
}

export const InputText = ({
    value,
    className,
    hasBorder = true,
    borderVariant = BorderVariant.LIGHT,
    placeholder = '',
    icon,
    height = '5rem',
    color = '#696b73',
    ...rest
}: ITextProps) => {
    return (
        <StyledInputContainer $height={height}>
            {icon && <IconContainer>{icon}</IconContainer>}
            <StyledInput
                type='text'
                className={classNames(className)}
                $hasBorder={hasBorder}
                $borderVariant={borderVariant}
                placeholder={placeholder}
                height={height}
                $color={color}
                $icon={!!icon}
                value={value as string}
                {...rest}
            />
        </StyledInputContainer>
    )
}
interface StyledInputProps {
    height?: string
    $color: string
    $hasBorder: boolean
    $borderVariant: BorderVariant
    $borderRadius?: string
    $padding?: string
    $paddingRight?: string
    $paddingLeft?: string
    $paddingTop?: string
    $paddingBottom?: string
    $icon?: boolean
}

const StyledInput = styled.input<StyledInputProps>`
    font-size: 1.4rem;
    font-weight: ${FontWeight.medium};
    width: 100%;
    height: ${props => (props.height ? props.height : 'auto')};
    font-family: 'Montserrat', sans-serif;

    ${props =>
        props.$color &&
        `
      color: ${props.$color};

      &::placeholder {
        color: ${props.$color};
      }
    `}

    ${props => {
        if (props.$hasBorder) {
            if (props.$borderVariant === BorderVariant.LIGHT) {
                return `
            border: 0.1rem solid #D9D9D9;
          `
            } else if (props.$borderVariant === BorderVariant.DARK) {
                return `
            border: 0.2rem solid rgba(103, 110, 125, 0.8);
          `
            }
        }
    }}
    border-radius: 1.5rem;

    ${props =>
        props.$icon ? 'padding: 1rem 1rem 1rem 4.5rem;' : 'padding: 1rem;'}

    padding-right: ${props =>
        props.$paddingRight ? `${props.$paddingRight};` : '1rem;'};

    &::placeholder {
        font-size: 1.4rem;
        font-weight: ${FontWeight.medium};
        opacity: 0.4; /* more transparent placeholder */
    }

    &:focus {
        outline: none;
    }
`

interface StyledInputContainerProps {
    $height?: string
}

const StyledInputContainer = styled.div<StyledInputContainerProps>`
    position: relative;
    width: 100%;
    height: ${props => props.$height};
`

const IconContainer = styled.div`
    position: absolute;
    left: 1.5rem;
    top: 50%;
    transform: translateY(-50%);
`
